import { useState } from "react";
import { Link } from "react-router-dom";
import { Share2 } from "lucide-react";
import ShareModal from "@/components/ShareModal";
import LoveLangHeader from "./LoveLangHeader";

export default function SiteFooter() {
  const [shareOpen, setShareOpen] = useState(false);
  const siteUrl = typeof window !== "undefined" ? window.location.origin : "https://lovelanguagefm.lovable.app";

  return (
    <footer className="border-t border-border mt-20 py-10 footer-safe-bottom">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <LoveLangHeader size="footer" />
          </div>
          <nav className="flex flex-col md:flex-row gap-4 md:gap-7">
            <Link to="/" className="text-[10px] text-muted-foreground hover:text-foreground uppercase tracking-widest font-sans transition-colors hover-lift">Listen</Link>
            <Link to="/dedicate" className="text-[10px] text-muted-foreground hover:text-foreground uppercase tracking-widest font-sans transition-colors hover-lift">Dedicate</Link>
            <Link to="/ukhozi" className="text-[10px] text-muted-foreground hover:text-foreground uppercase tracking-widest font-sans transition-colors hover-lift">Heard on Ukhozi FM</Link>
            <Link to="/how-it-works" className="text-[10px] text-muted-foreground hover:text-foreground uppercase tracking-widest font-sans transition-colors hover-lift">HOW IT'S DONE</Link>
          </nav>

          <button
            onClick={() => setShareOpen(true)}
            aria-label="Share Love Language FM"
            className="btn-press flex items-center gap-1.5 text-muted-foreground/40 hover:text-absa-red transition-colors self-start md:self-auto shrink-0"
          >
            <Share2 className="w-3.5 h-3.5" />
            <span className="font-sans text-[9px] uppercase tracking-[0.18em]">Share</span>
          </button>
        </div>

        <div className="mt-8 pt-5 border-t border-border">
          <p className="text-[10px] text-muted-foreground/30 font-sans leading-relaxed max-w-lg tracking-wide">
            Absa Life Limited is an insurer licensed to conduct life insurance business (I121). Registration number 1992/001738/06.
          </p>
        </div>
      </div>

      <ShareModal
        open={shareOpen}
        onClose={() => setShareOpen(false)}
        url={siteUrl}
        title="Love Language FM"
        description="The radio station made entirely out of your words. Say it in a hit song."
      />
    </footer>
  );
}
